import * as get from 'lodash/get';
import * as uniqBy from 'lodash/uniqBy';

import { ModelPortfolio, SecurityIdentifiersMapRequest } from '../domain';
import { PortfolioSecurityIdentifierMappingUtil } from './portfolio-security-identifier-mapping.util';

export class SecurityIdentifierTransformUtil {
	/**
		 * Creates a map request for security identifiers from the given holdings.
		 *
		 * This method processes an array of `ModelPortfolio` objects, extracting unique securities
		 * from their components based on their positions and weights. It then constructs a list of
		 * `SecurityIdentifiersMapRequest` objects, each containing an identifier and a map of security
		 * identifiers.
		 *
		 * @param {ModelPortfolio[]} holdings - An array of `ModelPortfolio` objects representing the holdings.
		 * @returns {SecurityIdentifiersMapRequest[]} An array of `SecurityIdentifiersMapRequest` objects containing unique securities.
		 */
	public static createSecurityIdentifiersMapRequest(holdings: ModelPortfolio[], filterZeroWeight: boolean = true): SecurityIdentifiersMapRequest[] {
		// Combine all tickers from all models in the family
		let uniqueSecurities: SecurityIdentifiersMapRequest[] = [];
		holdings.forEach(family => {
			get(family, 'components', []).filter(holding => {
				if (!filterZeroWeight) {
					return true;
				} else {
					return get(holding, 'weight') > 0;
				}
			}).forEach(child => {
				const childPosInfoKeys = Object.keys(child.posInfo || {});
				const positions = childPosInfoKeys.reduce((accumulator, key) => {
					return { ...accumulator, [key]: child.posInfo[key]?.stringValue || child.posInfo[key]?.numberValue };
				}, { assetId: child.assetId });
				uniqueSecurities.push({
					id: child.posInfo?.ticker?.stringValue || child.assetId,
					identifiers: PortfolioSecurityIdentifierMappingUtil.buildIdentifiersMap(positions)
				} as SecurityIdentifiersMapRequest);
			});
		});
		uniqueSecurities = uniqBy(uniqueSecurities, 'id');
		return uniqueSecurities;
	}
}
